import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { VueApplicationBootstrapService, VueUserSessionService, WINDOW } from '@vue/vueframework';

@Component({
  selector: 'app-root',
  templateUrl: './app-root.component.html',
  styleUrls: [ './app-root.component.scss' ],
  standalone: false
})
export class AppRootComponent implements OnInit {
  public constructor(private router: Router,
    private vueApplicationBootstrapService: VueApplicationBootstrapService,
    @Inject(WINDOW) private vueWindow: Window,
    private vueUserSessionService: VueUserSessionService,) {}
  public ngOnInit(): void {
    this.vueWindow.addEventListener('VueEventCASUserPasswordExpired', (e: CustomEvent) => {
      this.router.navigate([ '/passwordexpired' ], {
        state: {
          credentials: e.detail
        }
      });
    });

    this.vueUserSessionService
      .setAccountMaintenanceURL(this.vueWindow.location.origin + '/Connect/#/account/maintenance');
    this.vueUserSessionService
      .setPortalLogoutURL(this.vueWindow.location.origin + '/Connect/#/externalLogout');

    this.vueApplicationBootstrapService.performFullBootstrap();
  }
}
